import { useEffect } from 'react';

import { ensureNamespaces } from '../../i18n';
import LandingHeaderSection from './landingHeaderSection';
import LandingDeleteAccountSection from './landingDeleteAccountSection';
import LandingFooterSection from './landingFooterSection';
import { LandingPageRoot } from './landingPage.styles';

export default function DeleteAccountPage() {
  useEffect(() => {
    ensureNamespaces(['landing']);

    const scrollRoot = document.getElementById('app-scroll-root');
    if (scrollRoot) {
      scrollRoot.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <LandingPageRoot>
      <LandingHeaderSection anchorPrefix="/" />

      <LandingDeleteAccountSection />

      <LandingFooterSection />
    </LandingPageRoot>
  );
}
